import { useEffect, useState } from "react";


export function usePromise<T>(
    func: (() => Promise<T>)
): T | undefined {

    const [val, setVal] = useState<T | undefined>(undefined);

    useEffect(() => {
        let cancelled = false;
        func().then(v => {
            if (cancelled)
                return;
            setVal(v);
        });

        return function cancelFunction() {
            cancelled = true;
        }
    },
        [func]
    );

    return val;
}
